import { useEffect, useState } from 'react';
import { API_ENDPOINTS } from '@/api/endpoints.constant';
import { systemConfig } from '@/config/systemConfig';
import { masterDataIdbService } from '@/store/idbStorage/masterDataIdbService';
import { AqlLevelRow } from '@/utils/quantity-check.utils';
import { clivApiRequest } from '@/utils/apiClient';

const AQL_LEVELS_KEY = 'md_aqlLevels';

/**
 * Loads tenant AQL rows for offline sample recalculation.
 */
export function useAqlLevels(isEnabled: boolean): AqlLevelRow[] {
  const [rows, setRows] = useState<AqlLevelRow[]>([]);
  useEffect(() => {
    if (!isEnabled) {
      return;
    }
    let isActive = true;
    const load = async (): Promise<void> => {
      const cached = await masterDataIdbService.getEntity<AqlLevelRow[]>(AQL_LEVELS_KEY);
      if (isActive && cached?.length) {
        setRows(cached);
      }
      const response = await clivApiRequest<AqlLevelRow[]>({
        url: `${systemConfig.apiUrl}/${API_ENDPOINTS.META.AQL_LEVELS}`,
      });
      if (!isActive || !response.ok || !response.data) {
        return;
      }
      setRows(response.data);
      await masterDataIdbService.setEntity(AQL_LEVELS_KEY, response.data);
    };
    void load();
    return () => {
      isActive = false;
    };
  }, [isEnabled]);
  return rows;
}
